import { z } from 'zod';
import { createPortalToolOutputSchema } from './portal-tool.schemas';
import { PROXY_CONTROL_TOOL_NAME } from './portal-tool.constants';

export { PROXY_CONTROL_TOOL_NAME };

export const ProxyControlActionSchema = z.enum([
  'start',
  'stop',
  'status',
  'get-settings',
]);

export const ProxyControlInputSchema = z.object({
  action: ProxyControlActionSchema,
});

export const ProxyControlDataSchema = z.object({
  isRunning: z.boolean().optional(),
  port: z.number().nullable().optional(),
  httpsPort: z.number().nullable().optional(),
  interceptEnabled: z.boolean().optional(),
  matchReplaceEnabled: z.boolean().optional(),
});

export const ProxyControlOutputSchema = createPortalToolOutputSchema({
  dataSchema: ProxyControlDataSchema,
});

export type ProxyControlInput = z.infer<typeof ProxyControlInputSchema>;
export type ProxyControlOutput = z.infer<typeof ProxyControlOutputSchema>;
export type ProxyControlData = z.infer<typeof ProxyControlDataSchema>;
